import { TRANSLATIONS_EN } from './english';

export const TRANSLATIONS_UR: Record<keyof typeof TRANSLATIONS_EN, string> = {
    signupTitle: "رجسٹریشن",
    signupHeader: "اکاؤنٹ بنانے کے لیے براہ کرم درج ذیل معلومات درج کریں۔",
    mobileNumber: "موبائل نمبر",
    patientFirstname: "مریض کا پہلا نام",
    patientLastName: "مریض کا آخری نام",
    firstName: "پہلا نام",
    lastName: "آخری نام",
    patientDob: "مریض کی تاریخ پیدائش",
    patientGender: "مریض کی جنس",
    male: "مرد",
    female: "عورت",
    zipCode: "پوسٹل کوڈ",
    password: "پاس ورڈ",
    whoIsFillingForm: "یہ فارم کون پُر کر رہا ہے؟",
    legalGuardian: "دیکھ بھال کرنے والا",
    patient: "مریض",
    proceedButton: "آگے بڑھیں",
    belowTwelveNote: "آپ کی عمر کے پیش نظر ہمیں آپ کے والدین کی مدد درکار ہے۔ براہ کرم آلہ اپنے والد یا والدہ کے حوالے کریں یا ان سے رجسٹریشن کرنے کو کہیں۔",
    parent: "جی ہاں، میں والد یا والدہ ہوں",
    notParent: "نہیں، میں والد یا والدہ نہیں ہوں",
    twelveToEighteenNote: "مریض کی عمر کے پیش نظر ہمیں ان کے جوابات درکار ہیں۔ اگر مریض سوالنامے کے جواب دینے کے قابل ہے تو براہ کرم رجسٹریشن کے لیے آلہ مریض کے حوالے کریں۔",
    imPatient: "جی ہاں، میں مریض ہوں",
    notPatient: "نہیں، میں مریض نہیں ہوں",
    patientIncapable: "مریض جواب دینے کے قابل نہیں ہے",
    legalGuardianTitle: "اپنی تفصیلات درج کریں",
    guardianFirstName: "دیکھ بھال کرنے والے کا پہلا نام",
    guardianLastName: "دیکھ بھال کرنے والے کا آخری نام",
    guardianEmail: "ای میل ایڈریس",
    emergencyContactTitle: "ہنگامی رابطے کی تفصیلات درج کریں",
    emergencyFirstName: "پہلا نام",
    emergencyLastName: "آخری نام",
    emergencyPhoneNumber: "فون نمبر",
    relationType: "رشتہ",
    canShareDetail: "کیا ہنگامی صورت حال میں ہم آپ کی تفصیلات اوپر درج رابطہ شخص کے ساتھ شیئر کر سکتے ہیں؟",
    yes: "جی ہاں",
    no: "نہیں",
    reasonForVisitTitle: "ملاقات کی وجہ",
    sickVisit: "بیماری کے لیے ملاقات",
    annualVisit: "معمول کا معائنہ / سالانہ ملاقات",
    welcomeTitle: "اسکریننگ کا تعارف",
    welcomeSubTitle: "براہ کرم آنے والے سوالات کے جواب دے کر علامات کی نشاندہی کریں۔ اس میں آپ کے 8 سے 10 منٹ لگیں گے۔",
    getStartedButton: "شروع کریں",
    adhdNote: "درج ذیل سوالنامہ آپ کے قانونی سرپرست یا والدین کو مکمل کرنا ہے۔ براہ کرم آلہ ان کے حوالے کریں۔",
    handoverButton: "حوالے کریں",
    loginTitle: "لاگ اِن",
    loginSubTitle: "آپ کی معلومات محفوظ اور خفیہ رہیں گی۔",
    forgotPassword: "پاس ورڈ بھول گئے؟",
    forgotPasswordSubTitle: "براہ کرم وہ فون نمبر درج کریں جو آپ Small Joys میں لاگ اِن کرنے کے لیے استعمال کرتے ہیں۔",
    backToLogin: "لاگ اِن پر واپس جائیں",
    resetPassword: "پاس ورڈ دوبارہ ترتیب دیں",
    resetPasswordSubTitle: "براہ کرم نیا پاس ورڈ بنائیں۔ آپ کا پاس ورڈ کم از کم 8 حروف پر مشتمل ہونا چاہیے۔",
    enterCodeTitle: "براہ کرم اس نمبر پر بھیجا گیا یک وقتی تصدیقی کوڈ درج کریں",
    change: "تبدیل کریں",
    verify: "تصدیق کریں",
    notReceivedCode: "آپ کو کوڈ موصول نہیں ہوا؟",
    resendCode: "کوڈ دوبارہ بھیجیں",
    completedScreener: "آپ نے ایک اسکریننگ مکمل کر لی ہے",
    nextScreener: "اگلی اسکریننگ پر جائیں",
    thankYou: "شکریہ!",
    completedQuestionnaires: "آپ نے تمام سوالنامے مکمل کر لیے ہیں۔",
    handover: "براہ کرم آلہ منتظم کے حوالے کریں",
    suicidalTitle: "آپ کو آج کسی سے بات کرنے کی ضرورت ہے",
    suicidalSubTitle: "اگر آپ خود کو نقصان پہنچانے کے بارے میں سوچ رہے ہیں، کسی دوست یا عزیز کے بارے میں فکر مند ہیں، یا جذباتی مدد چاہتے ہیں تو ہمیں کال کریں اور ہم سے بات کریں۔ ہم دن رات، ہفتے کے ساتوں دن دستیاب ہیں۔",
    call: "کال کریں",
    officialWebsite: "آفیشل ویب سائٹ",
    oneDrinkEquals: "ایک مشروب کے برابر ہے",
    ozBeer: "اونس بیئر",
    ozWine: "اونس شراب",
    ozLiquor: "اونس تیز شراب",
    ozLiquorOneShot: "ایک شاٹ",
    checkInCompleteTitle: "چیک اِن مکمل ہو گیا",
    checkInCompleteMessage: "چیک اِن کرنے کا شکریہ۔ براہ کرم اپنی ملاقات کے لیے استقبالیہ پر تشریف لے جائیں۔",
};
